export const ACTION_TYPE = 'actionType';
export const DATE = 'date';
export const DELTA = 'delta';
export const TIME_OF_DAY = 'timeOfDay';
export const TIME_UNIT = 'timeUnit';
export const TIME_ZONE_STRATEGY = 'timeZoneStrategy';